import { Placeholder as SitecorePlaceholder } from '@sitecore-jss/sitecore-jss-nextjs';

import type {
	ComponentRendering,
	PlaceholderComponentProps,
	RouteData,
} from 'models/sitecore';
import { hasProps } from 'utils/collection';

export interface Props<T extends Record<keyof T, unknown>> extends Omit<
	PlaceholderComponentProps,
	'rendering'
> {
	name:
		| 'jula-account'
		| 'jula-account-details'
		| 'jula-empty'
		| 'jula-footer'
		| 'jula-header'
		| 'jula-inspiration'
		| 'jula-layout-landscape'
		| 'jula-layout-left'
		| 'jula-layout-right'
		| 'jula-layout-square'
		| 'jula-legal'
		| 'jula-main'
		| 'jula-media-caption'
		| 'jula-payment-method'
		| 'jula-side-navigation'
		| 'jula-size-guide'
		| 'jula-teaser';
	partialProps?: T;
	render?: PlaceholderComponentProps['render']; // Isn't fully typed through extends for some reason
	rendering: ComponentRendering | RouteData | undefined;
}

/** A wrapper for Sitecore's Placeholder component */
export default function Placeholder<T extends Record<keyof T, unknown>>({
	...props
}: Props<T>) {
	if (!hasProps(props, 'rendering')) {
		return null;
	}

	return <SitecorePlaceholder {...props} />;
}
Placeholder.displayName = 'Placeholder';
